<mat-card *ngIf="tier">

  <mat-card-title>
    What you get:
  </mat-card-title>

  <mat-card-content *ngIf="tier">

    <ul>
      <li *ngFor="let tierInfo of tierInfos">
        <div *ngIf="tier && tierInfo"
             [class.not-included]="tierInfo.renderNotIncluded" class="tier-info">
          <mat-icon *ngIf="tierInfo.renderIncluded">task_alt</mat-icon>
          <mat-icon *ngIf="tierInfo.renderNotIncluded">block</mat-icon>
          <span>{{ tierInfo.i18n | translate:tierInfo }}</span>
        </div>
      </li>
    </ul>

    <button mat-raised-button color="primary" (click)="addToCart()" *ngIf="renderCartItem" [disabled]="disabled">
      <mat-icon>add_shopping_cart</mat-icon>&nbsp;&nbsp;{{ 'cart.add' | translate }}
    </button>

  </mat-card-content>
</mat-card>
